"use strict";

var _context3, _context4, _context5, _context6;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  hasWordStartingWith: true,
  findIndexes: true,
  htmlEntities: true,
  makeUid: true
};
exports.findIndexes = findIndexes;
exports.hasWordStartingWith = hasWordStartingWith;
_Object$defineProperty(exports, "htmlEntities", {
  enumerable: true,
  get: function () {
    return _htmlUtils.htmlEntities;
  }
});
_Object$defineProperty(exports, "makeUid", {
  enumerable: true,
  get: function () {
    return _uid.makeUid;
  }
});
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _concatPaths = require("./concat-paths");
_forEachInstanceProperty(_context3 = _Object$keys(_concatPaths)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _concatPaths[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _concatPaths[key];
    }
  });
});
var _formatCurrency = require("./format-currency");
_forEachInstanceProperty(_context4 = _Object$keys(_formatCurrency)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formatCurrency[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatCurrency[key];
    }
  });
});
var _formatNumber = require("./format-number");
_forEachInstanceProperty(_context5 = _Object$keys(_formatNumber)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formatNumber[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatNumber[key];
    }
  });
});
var _formatPhoneNumber = require("./format-phone-number");
_forEachInstanceProperty(_context6 = _Object$keys(_formatPhoneNumber)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formatPhoneNumber[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatPhoneNumber[key];
    }
  });
});
var _htmlUtils = require("./html-utils");
var _uid = require("./uid");
function hasWordStartingWith(haystack = '', needle = '') {
  var _context;
  if (needle === '') {
    return true;
  }
  return (0, _reduce.default)(_context = findIndexes(haystack, needle)).call(_context, (memo, index) => {
    if (memo) {
      return memo;
    }
    const previousCharacter = haystack[index - 1] || '';
    return index === 0 || /(\s|\n\|r\n)/.test(previousCharacter);
  }, false);
}
function findIndexes(haystack = '', needle = '', settings = {
  ignoreCase: true
}) {
  const {
    ignoreCase
  } = settings;
  if (ignoreCase) {
    haystack = haystack.toLowerCase();
    needle = needle.toLowerCase();
  }
  const firstIndex = (0, _indexOf.default)(haystack).call(haystack, needle);
  let indexes = [];
  if (firstIndex > -1) {
    const size = needle.length || 1;
    const remainingHaystack = (0, _slice.default)(haystack).call(haystack, firstIndex + size);
    let additionalIndexes = [];
    if (remainingHaystack.length) {
      var _context2;
      additionalIndexes = (0, _map.default)(_context2 = findIndexes(remainingHaystack, needle, settings)).call(_context2, index => index + firstIndex + size);
    }
    indexes = [firstIndex, ...additionalIndexes];
  }
  return indexes;
}